/** Shared by import history and the Stripe research panel. Replacement is
 * an intentional terminal state, not a failed attempt to identify a client. */
export function profileResearchDiagnosticKey(detail: string | null): string | null {
  if (!detail) return null;
  const prefix = "staffConsole.adminImports.reason.";
  if (/^dossier_curated:\d+$/.test(detail)) return prefix + "profileAccepted";
  if (detail === "research_attempt_replaced") return prefix + "researchAttemptReplaced";
  if (detail === "claim_expired" || detail === "research_failed:claim_expired") return prefix + "claimExpired";
  if (detail.toLowerCase().includes("prompt is too long")) return prefix + "contextTooLarge";
  return null;
}
